import { createContext } from "react";

export const historyContext = createContext({});
export const authContext = createContext({ isAuth: false });
